export const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024;
export const ALLOWED_EXTENSIONS = ["csv", "xlsx"];
export const ALLOWED_ACCEPT = ".csv,.xlsx,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const BATCH_STATUS = {
  PROCESSING: "processing",
  DONE: "done",
  WARNING: "warning",
  FAILED: "failed",
};
